const STORAGE_KEY = 'tlaaq_salla_invitation'
const MAX_AGE_MS = 24 * 60 * 60 * 1000
let memoryDraft: { token: string; capturedAt: number } | null = null

export function clearSallaInvitation(): void {
  memoryDraft = null
  try { window.sessionStorage.removeItem(STORAGE_KEY) } catch { /* Storage may be unavailable. */ }
}

export function readSallaInvitation(): string | null {
  try {
    const stored = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) ?? 'null') ?? memoryDraft
    if (stored && typeof stored.token === 'string' && /^[A-Za-z0-9_-]{43}$/.test(stored.token)
      && typeof stored.capturedAt === 'number' && Date.now() - stored.capturedAt < MAX_AGE_MS) return stored.token
  } catch {
    if (memoryDraft && Date.now() - memoryDraft.capturedAt < MAX_AGE_MS) return memoryDraft.token
  }
  clearSallaInvitation()
  return null
}

/** Keep the capability in this tab, never a query parameter or auth request. */
export function captureSallaInvitation(): string | null {
  const url = new URL(window.location.href)
  const path = url.pathname.replace(/\/+$/, '')
  // A pending invitation must not hijack an explicit Custom OAuth callback or
  // an unrelated application route. Resume it only on its auth handoff paths.
  if (path === '/salla-oauth') clearSallaInvitation()
  if (!['/salla-invitation', '/login', '/register', '/forgot-password', '/reset-password'].includes(path)) return null
  if (path === '/salla-invitation' && url.hash) {
    const token = new URLSearchParams(url.hash.slice(1)).get('token')
    clearSallaInvitation()
    window.history.replaceState({}, '', '/salla-invitation')
    if (!token || !/^[A-Za-z0-9_-]{43}$/.test(token)) return null
    const draft = { token, capturedAt: Date.now() }
    try { window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(draft)) } catch { memoryDraft = draft }
    return token
  }
  return readSallaInvitation()
}
